export interface EnrollmentField {
    FieldCode: string
    FieldValue: string
}

export enum EnrollmentFieldCodes {
    ACCHOLDERNAME = 'ACCHOLDERNAME',
    ACCOUNTNB = 'ACCOUNTNB',
    AGENTEMAIL = 'AGENTEMAIL',
    AGENTFN = 'AGENTFN',
    AGENTID = 'AGENTID',
    AGENTLN = 'AGENTLN',
    APPADD1 = 'APPADD1',
    APPADD2 = 'APPADD2',
    APPCITY = 'APPCITY',
    APPDOB = 'APPDOB',
    APPDT = 'APPDT',
    APPEMAIL = 'APPEMAIL',
    APPFN = 'APPFN',
    APPGEN = 'APPGEN',
    APPLN = 'APPLN',
    APPMI = 'APPMI',
    APPST = 'APPST',
    APPZIP = 'APPZIP',
    ATESTPROOF = 'ATESTPROOF',
    AUTHREPADD1 = 'AUTHREPADD1',
    AUTHREPADD2 = 'AUTHREPADD2',
    AUTHREPCITY = 'AUTHREPCITY',
    AUTHREPIND = 'AUTHREPIND',
    AUTHREPNAME = 'AUTHREPNAME',
    AUTHREPPHONE = 'AUTHREPPHONE',
    AUTHREPREL = 'AUTHREPREL',
    AUTHREPST = 'AUTHREPST',
    AUTHREPZIP = 'AUTHREPZIP',
    APPPHONE = 'APPPHONE',
    CELLPHONE = 'CELLPHONE',
    COBBIN = 'COBBIN',
    COBEFFDT = 'COBEFFDT',
    COBPCN = 'COBPCN',
    COBTERMDT = 'COBTERMDT',
    COMPLETEIND = 'COMPLETEIND',
    CONF = 'CONF',
    CONTRACT = 'CONTRACT',
    CUID = 'CUID',
    CULTURE = 'CULTURE',
    EFFDT = 'EFFDT',
    EFTTYPE = 'EFTTYPE',
    ELECTION = 'ELECTION',
    FININSTNAME = 'FININSTNAME',
    HICN = 'HICN',
    LANG = 'LANG',
    LEGREPEMAIL = 'LEGREPEMAIL',
    LTCFACILITY = 'LTCFACILITY',
    LTCPHONE = 'LTCPHONE',
    MAILADD1 = 'MAILADD1',
    MAILADD2 = 'MAILADD2',
    MAILCITY = 'MAILCITY',
    MAILST = 'MAILST',
    MAILZIP = 'MAILZIP',
    MEDA = 'MEDA',
    MEDB = 'MEDB',
    NOTES = 'NOTES',
    OTHCVRG = 'OTHCVRG',
    OTHCVRGGRP = 'OTHCVRGGRP',
    OTHCVRGID = 'OTHCVRGID',
    OTHCVRGNAME = 'OTHCVRGNAME',
    PLANNAME = 'PLANNAME',
    PLANST = 'PLANST',
    PLANTYPE = 'PLANTYPE',
    PLANYEAR = 'PLANYEAR',
    POA = 'POA',
    PWO = 'PWO',
    ROUTINGNB = 'ROUTINGNB',
    SEPEFFDT = 'SEPEFFDT',
    SEPREASONCD = 'SEPREASONCD',
    SOA = 'SOA',
    SUFFIX = 'SUFFIX',
    TITLE = 'TITLE',
    DEX = 'DEX',
    AGENTDEX = 'AGENTDEX',
    APPSIGNEDIND = 'APPSIGNEDIND',
    AUTHREPSIGNEDIND = 'AUTHREPSIGNEDIND',
    ADMINID = 'ADMINID',
    LEADTYPE = 'LEADTYPE',
    CONTACTTYPE = 'CONTACTTYPE',
    DATEOFRECEIPT = 'RECPDT',
    POVERIND = 'POVERIND',
    CC = 'CC',
    UNMTHS = 'UNMTHS',
    SECMBRID = 'SECMBRID',
    RELCD = 'RELCD',
    FAMILYID = 'FAMILYID',
    PERSONCD = 'PERSONCD',
    LANGFORMAT = 'LANGFORMAT',
    AUTHREPCOPYIND = 'AUTHREPCOPYIND',
    ETHNICITY = 'ETHNICITY',
    RACE = 'RACE',
    CURRENTGENDER = 'CURRENTGENDER',
    CURRENTGENDEROTH = 'CURRENTGENDEROTH',
    GENDERNPRONOUN = 'GENDERNPRONOUN',
    GENDERNPRONOUNOTH = 'GENDERNPRONOUNOTH',

    INDREPNAME = 'INDREPNAME',
    RELTOENROLL = 'RELTOENROLL',
    NPN = 'NPN',
    INDREPIND = 'INDREPIND'
}
